class UserPermissions {
  constructor() {
    this.permissions = [];
    this.superUser = false;
  }

  setPermissions(permissions) {
    this.permissions = permissions;
  }

  setSuperUser(superUser) {
    this.superUser = superUser;
  }

  hasPermissions(has) {
    let hasPermission = false;
    if (this.superUser === true) {
      hasPermission = true;
    } else if (this.permissions.length > 0 && this.permissions.indexOf(has) !== -1) {
      hasPermission = true;
    }
    return hasPermission;
  }
}
if (!window.UserPermissions) {
  window.UserPermissions = new UserPermissions();
}

export default {
  UserPermissions: window.UserPermissions,
};



// WEBPACK FOOTER //
// ./src/utils/user-permissions.js